var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineReceiptSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.32 7.75-7.75 7.75H9zM2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.54 17.86-.6-.8a.354.354 0 0 0-.24-.15c-.09 0-.17.04-.25.12l-.55-.51.55.51c-.97 1.04-1.76.94-2.15.79-.39-.16-1.05-.64-1.05-2.12V9.07c0-2.78.89-3.71 3.53-3.71h4.45c2.64 0 3.53.94 3.53 3.71v6.63c0 1.48-.66 1.97-1.05 2.12-.38.15-1.17.25-2.15-.79a.369.369 0 0 0-.26-.12c-.09 0-.17.06-.24.15l-.59.79c-.38.5-.91.78-1.47.78-.56 0-1.09-.28-1.46-.77zm-.76-2.45c.53.03 1.02.3 1.35.75l.6.8c.17.22.36.22.52 0l.59-.79c.33-.45.83-.72 1.36-.75.52-.04 1.05.19 1.43.6.28.3.46.38.53.4-.01-.05.08-.25.08-.71V9.08c0-2.05-.31-2.21-2.03-2.21H9.76c-1.72 0-2.03.16-2.03 2.21v6.63c0 .46.09.66.12.72.03-.04.21-.12.48-.42 0-.01.01-.01.02-.02.37-.36.85-.58 1.34-.58h.09z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineReceiptSquare);
export default __webpack_public_path__ + "static/media/vuesax-outline-receipt-square.dea3a692dac608e91e090ffababef460.svg";
export { ForwardRef as ReactComponent };